// extracted by mini-css-extract-plugin
export default {"tags":"tags--ZpOUi","item":"item--xfwfM","arrow":"arrow--R9pT8","allTags":"allTags--gEUHX","close":"close--IlH4h"};